import React, { useEffect, useState } from 'react';
import { getNomenclatorTypes } from '../services/EntityController';
import { WindowLoader } from 'medere-ui-framework';
import { healthcheck } from '../services/HealthCheckController';

interface VaadinViewProps {
  route: string;
  name: string;
}

const VaadinView: React.FC<VaadinViewProps> = ({ route, name }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    healthcheck().finally(() => setReady(true));
  }, [route, name]);

  if (!ready) return (
    <div className="flex justify-center items-center h-screen w-screen">
      <WindowLoader showLoader/>
    </div>
  );

  return (
    <div className='viewContainer' style={{ height: '100%', overflow: 'hidden' }}>
      <iframe
        src={`/vaadinapp/#!${route}`}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title={name}
      />
    </div>
  );
};

export default VaadinView;
